<div class="card card-nb h-100 order">
  <div class="card-body">
    <div class="d-flex justify-content-between align-items-start">
      <div class="h3 d-flex align-items-center">
        <div>[{{draft.portOrder.applianceId}}]</div>
        <div class="ml-1">{{instancename}}</div>
      </div>
    </div>

    <div class="subinformations">
      <div class="d-flex flex-column flex-sm-row justify-content-between">
        <div class="p-0 m-0">
          <div *ngIf="contactName" class="d-flex align-items-center mt-2 mb-2">
            <i class="fas fa-user red mr-2"></i>
            <div class="">{{ contactName }}</div>
          </div>


          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-clipboard-list red mr-2"></i>
            <div>{{ 'port_phone_number' | i18next }}</div>
          </div>

          <div class="d-flex align-items-center mb-2">
            <i class="fas fa-forward red mr-2"></i>
            <div class="mr-2">{{ isPhoneBillStep ? ('upload_phone_bill' | i18next) : ('upload_port_form' | i18next) }}
            </div>
          </div>

          @if (isBlock) {
            <app-order-draft-card-block
              [numberFrom]="blockNumber.numberFrom"
              [numberTo]="blockNumber.numberEnd">
            </app-order-draft-card-block>
          }

          @if (!isBlock) {
            <app-order-draft-card-single
              [phoneNumbers]="phoneNumbers">
            </app-order-draft-card-single>
          }
        </div>
        <div class="p-0 m-0"></div>
      </div>
    </div>
  </div>

  <div class="row subinformations pb-1 p-3">
    <div class="d-flex ml-auto align-items-end flex-column mt-auto">
      <div class="mt-auto">
        <span class="mr-2 status-text text-muted">
          @if (showDelete) {
            <button class="btn btn-link mr-2 red"
              (click)="onDelete()"
              title="{{ 'delete_draft_tooltip' | i18next }}">
              {{ 'delete_draft_tooltip' | i18next }}
            </button>
          }
          @if (showCreate) {
            <button class="btn btn-outline-primary"
              (click)="onContinue()"
              title="{{ 'continue_draft_tooltip' | i18next }}">
              {{ 'continue_draft_tooltip' | i18next }}
            </button>
          }
        </span>
      </div>
    </div>
  </div>
</div>